import classNames from 'classnames';
import * as React from 'react';

import { ErrorLabel } from '../errorLabel';
import { TitleLabel } from '../titleLabel';

type Props = {
  errorMessage?: ErrorMessageType;
  disabled?: boolean;
  label?: string | React.ReactNode;
  value?: string;
  name: string;
  requiredMark?: boolean;
  children: React.ReactNode | React.ReactChildren | React.ReactElement;
  additionalInfo?: string;
  additionalComponent?: AnyFunction;
};

export const InputWrapComponent = (props: Props): React.ReactElement | any => {
  const { errorMessage, disabled, label, children, name, requiredMark, additionalInfo, additionalComponent } = props;

  const hasError = Boolean(errorMessage);

  return (
    <div
      className={classNames('input-wrap', {
        error: hasError,
        disabled: disabled,
      })}
    >
      <div className='input-info'>
        {label && <TitleLabel name={name} label={label} requiredMark={requiredMark} />}
        {label && (
          <span className='additional-info' {...testAnchors.useField(name, TEST_ANCHORS.fieldStructure.additional)}>
            {additionalInfo}
          </span>
        )}
      </div>
      {children}
      {hasError && <ErrorLabel errorMessage={errorMessage} name={name} />}
      {additionalComponent && additionalComponent()}
    </div>
  );
};
